import React from "react";
import { RiArrowRightSLine } from "react-icons/ri";

interface IButtonProps {
  label: string;
  type?: "button" | "submit" | "reset";
  classNames?: string;
  btnType?: string,
  onClick?: () => void;
  arrow?: boolean,
  disabled?: boolean
}

const Button: React.FC<IButtonProps> = ({ label, type = "button", classNames, btnType = 'btn-primary-green', onClick, arrow, disabled = false }) => {
  return (
    <button
      disabled={disabled}
      type={type}
      className={`${btnType} ${classNames || ''} ${arrow ? 'flex items-center' : ''} ${disabled ? 'opacity-70 cursor-not-allowed' : ''} `}
      onClick={onClick}>
      {label}
      {
        arrow && <RiArrowRightSLine className="text-xl" />
      }
    </button>
  );
};

export default Button;
